import $ from 'jquery';
import Swiper from 'swiper/bundle';

import 'swiper/swiper-bundle.css';

new Swiper('.home-slider', {
    loop: true,
    effect: 'fade',
    pagination: {
        el: '.slider-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.slider-next',
        prevEl: '.slider-prev',
    },
    autoplay: {
        delay: 5000,
    },
});

$('.desc-toggle').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    $('.home-desc-paragraph').toggleClass('active');
});

let promotionsSlider, blogSlider;
const breakPoint = window.matchMedia('(max-width:1350px)');

const promotionsSliderFunc = function () {
    promotionsSlider = new Swiper('.promotions-slider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 50,
        pagination: {
            el: '.promotion-pagination',
            clickable: true,
        },
        navigation: false,
        autoHeight: true,
        breakpoints: {
            750: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    });
};

new Swiper('.brands-slider', {
    loop: false,
    slidesPerView: 2,
    pagination: {
        el: '.brands-pagination',
        clickable: true,
    },
    navigation: false,
    autoHeight: true,
    watchOverflow: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    spaceBetween: 20,
    breakpoints: {
        750: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 5,
        },
    },
});

new Swiper('.occasions-slider', {
    loop: false,
    slidesPerView: 1,
    watchOverflow: true,
    spaceBetween: 50,
    pagination: {
        el: '.occasions-pagination',
        clickable: true,
    },
    navigation: false,
    autoHeight: true,
    breakpoints: {
        750: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        },
    },
});

const blogSliderFunc = function () {
    blogSlider = new Swiper('.blog-slider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 50,
        pagination: {
            el: '.blog-pagination',
            clickable: true,
        },
        navigation: false,
        autoHeight: true,
        breakpoints: {
            750: {
                slidesPerView: 2,
                autoHeight: false,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    });
};

const breakpointChecker = function () {
    if (breakPoint.matches === true) {
        promotionsSliderFunc();
        blogSliderFunc();
    } else if (breakPoint.matches === false) {
        if (promotionsSlider !== undefined) {
            promotionsSlider.destroy(true, true);
            blogSlider.destroy(true, true);
        }
    }
};

breakpointChecker();
breakPoint.addListener(breakpointChecker);
